import { Injectable } from '@angular/core';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { ResidentCarPersonalAccountPageInterface } from '@zaoblako/shared/modules/cctv/dtos/resident-car/personal-account/resident-car-personal-account-page.dto';
import type { ResidentCarPersonalAccountQueryInterface } from '@zaoblako/shared/modules/cctv/dtos/resident-car/personal-account/resident-car-personal-account-query.dto';
import type { ResidentCarFindInterface } from '@zaoblako/shared/modules/cctv/dtos/resident-car/resident-car-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountResidentCarService extends BaseService {
  protected baseUrl = '/personal-account/cctv/resident-car';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public getCardDescriptor(): Observable<CardDescriptorInterface> {
    return this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`);
  }

  public findPage(
    queryParams: ResidentCarPersonalAccountQueryInterface
  ): Observable<ResidentCarPersonalAccountPageInterface> {
    return this.http.get<ResidentCarPersonalAccountPageInterface>(`${this.baseUrl}/items`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restore(id: number): Observable<ResidentCarFindInterface> {
    return this.http.post<ResidentCarFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }
}
